import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SellerComponent } from './seller-dashboard/seller.component';
import { AdvanceSalesComponent } from './advance-sales/advance-sales.component';
import { ReferralsComponent } from './referrals/referrals.component';
import { BusinessDashboardCheckComponent } from './my-account/components/business-dashboard-check/business-dashboard-check.component';
import { SellerRoutingModule } from './seller-routing.module';
import { Ng2ImgMaxModule } from 'ng2-img-max';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { NewActivationPageComponent } from './my-account/components/new-activation-page/new-activation-page.component';
import { BusinessLegalInformationComponent } from './my-account/components/new-activation-page/business-legal-information/business-legal-information.component';
import { ContactInformationComponent } from './my-account/components/new-activation-page/contact-information/contact-information.component';
import { BusinessInformationComponent } from './my-account/components/new-activation-page/business-information/business-information.component';
import { ContractDeliveryAddressComponent } from './my-account/components/new-contract-page/contract-delivery-address/contract-delivery-address.component';
import { BusinessContractDataComponent } from './my-account/components/new-contract-page/business-contract-data/business-contract-data.component';
import { BusinessBankAccountComponent } from './my-account/components/new-contract-page/business-bank-account/business-bank-account.component';
import { NewContractPageComponent } from './my-account/components/new-contract-page/new-contract-page.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { OtpDialogComponent } from './my-account/components/new-activation-page/contact-information/OtpDialogComponent';
@NgModule({
  declarations: [
    SellerComponent,
    AdvanceSalesComponent,
    ReferralsComponent,
    BusinessDashboardCheckComponent,
    NewActivationPageComponent,
    BusinessInformationComponent,
    ContactInformationComponent,
    BusinessLegalInformationComponent,
    NewContractPageComponent,
    BusinessBankAccountComponent,
    BusinessContractDataComponent,
    ContractDeliveryAddressComponent,
    OtpDialogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    SellerRoutingModule,
    Ng2ImgMaxModule,
    MatTableModule,
    MatIconModule,
    MatRadioModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
})

export class SellerModule { }
